module.exports = __webpack_public_path__ + "static/media/market_coin.52a2e162.svg";